import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from '../select-next';
import USStates from './us-states-with-old-select';

const StateNextOld = props => {
  const {
    'data-cv-test': dataCvTest,
    cosigner,
    showSameStateText,
    hideErrorMessage,
    scrollTag
  } = props;

  return (
    <BaseSelect
      name="state"
      label="State"
      options={USStates}
      transparent
      disabledStateValue={{ value: 'default', label: 'State' }}
      {...props}
      data-cv-test-override={dataCvTest || 'addressState'}
      cosigner={cosigner}
      showSameStateText={showSameStateText}
      hideErrorMessage={hideErrorMessage}
      scrollTag={scrollTag}
    />
  );
};

StateNextOld.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string,
  cosigner: PropTypes.bool,
  showSameStateText: PropTypes.bool,
  scrollTag: PropTypes.string
};

StateNextOld.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': '',
  cosigner: false,
  showSameStateText: false,
  scrollTag: null
};

export default StateNextOld;
